const UA = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
const standalone = () => window.navigator.standalone || window.matchMedia?.("(display-mode: standalone)").matches;

export const isAndroid = /Android/i.test(UA);
export const isInApp = () => !standalone() &&
  (/; wv\)|FBAN|FBAV|Instagram|Line\/|WhatsApp|MicroMessenger|TikTok|musical_ly/i.test(UA) || (/iPhone|iPad|iPod/.test(UA) && !/Safari\//.test(UA)));
export const chromeIntent = () =>
  `intent://${window.location.host}${window.location.pathname}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(window.location.href)};end`;

export function reportClientError(err, extra = {}) {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-error`, {
      method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
      body: JSON.stringify({ message: String(err?.message || err).slice(0, 500), stack: String(err?.stack || "").slice(0, 2000),
        url: window.location.href, ua: UA, ...extra }),
    }).catch(() => {});
  } catch {}
}
